import React, { useState, useEffect } from "react";
import { Container, List } from "./styles";
import Details from "./Details/Details";
import CurrentActivity from "./CurrentActivity/CurrentActivity";
import { SoldProducts } from "./SoldProducts";
import Products from "./Products/Products";
import Archive from "./Archive/Archive";
import ReOpen from "./ReOpen/ReOpen";
import { IconButton, Typography } from "@material-ui/core";
import { ContactBar } from "../Chat/styles";
import { Close } from "@material-ui/icons";
import { MoreActions } from "./MoreActions";
import { useContactsState } from "../../contexts";

function ContactDetails({ setShowSidebar }) {
  const { currentContact, spotlight } = useContactsState();
  const [currentContactId, setCurrentContactId] = useState(currentContact.id);

  useEffect(() => {
    if (currentContactId != currentContact.id) {
      setCurrentContactId(currentContact.id);
    }
  }, [currentContact]);

  return (
    <Container>
      <ContactBar
        style={{
          justifyContent: "justify-content",
          alignItems: "center",
          paddingLeft: 10,
          paddingRight: 10,
        }}
      >
        <IconButton onClick={() => setShowSidebar(false)}>
          <Close />
        </IconButton>

        <Typography component="span"> Informações do contato</Typography>
        <MoreActions customer={currentContact} />
      </ContactBar>

      {!spotlight ? (
        <List style={{ padding: 0, margin: 0, backgroundColor: "#FBFBFB" }}>
          <Details customer={currentContact} />

          <CurrentActivity customer={currentContact} />

          <Products customer={currentContact} />

          <SoldProducts customer={currentContact} />

          {currentContact?.status !== "filed" && (
            <Archive customer={currentContact} />
          )}

          {currentContact?.status == "filed" && (
            <ReOpen customer={currentContact} />
          )}
        </List>
      ) : (
        spotlight
      )}
    </Container>
  );
}

export default ContactDetails;
